// extracted by mini-css-extract-plugin
export var currencyInput = "_m7-1";
export var currencySymbol = "_m7-0";